import { render, staticRenderFns } from "./WeekTimeComponent.vue?vue&type=template&id=0061db9b"
import script from "./WeekTimeComponent.vue?vue&type=script&lang=js"
export * from "./WeekTimeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../production-parity-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports